module.exports = __webpack_public_path__ + "img/hrlogo.60f0afbf.png";